module.exports = __webpack_public_path__ + "media/application/images/svgs/underline-dddc0a4e7cbc749de212f579cd05fa91.svg";